import React, {memo} from 'react';
import { Button } from 'reactstrap';

function SkipLink() {
    const skipToMain = (e) => {
        e.preventDefault();
        var target = document.getElementById("mainContentWell");
        target.setAttribute('tabindex', '-1');
        target.focus();
    };
    return (
        <div className="skip-link">
            <Button color="primary" onClick={(e) => skipToMain(e)}>Skip to Main Content</Button>
        </div>
    );
}

export default memo(SkipLink);